const coolingStageTableItems = [
  {
    name: 'coolingType',
    label: 'asset-information.cooling-stages.cooling-type',
    required: true,
  },
  {
    name: 'nominalPotency',
    label: 'asset-information.cooling-stages.nominal-potency',
    required: true,
  },
  {
    name: 'oilEnvironmentTopGradient',
    label: 'asset-information.cooling-stages.environment-oil-top-gradient',
    required: false,
  },
  {
    name: 'windingGradientHOil',
    label: 'asset-information.cooling-stages.winding-gradient-h-oil',
    required: false,
  },
  {
    name: 'windingGradientXOil',
    label: 'asset-information.cooling-stages.winding-gradient-x-oil',
    required: false,
  },
  {
    name: 'windingGradientYOil',
    label: 'asset-information.cooling-stages.winding-gradient-y-oil',
    required: false,
  },
];

export default coolingStageTableItems;
